<template>
    <div class="meeting-details">
        <header class="d-flex align-items-center font-size-lg py-2 px-3 event-details-header">
            <span class="fw-bold">Event Details</span>
            <i class="ms-auto fas fa-times-circle text-danger cursor-pointer" @click="closeDialog()"></i>
        </header>
        <section class="event-details-body">
            <section class="event-details-layout mb-2">
                <div class="d-flex align-items-center justify-space-between fw-bold font-size-lg pb-2">
                    {{ eventTitle }}
                </div>
                <section class="meeting-actions mt-2">
                    <div v-if="shouldShowJoinBtn" class="btn btn-primary py-1 me-2" @click="joinMeeting()">Join</div>
                    <template v-if="isOrganizer">
                        <template v-if="!isRecurring">
                            <button
                                type="button"
                                class="btn btn-sm meeting-btn-outline text-primary me-2"
                                @click="editMeeting(false)"
                            >
                                Edit
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm meeting-btn-outline text-danger me-2"
                                @click="cancelMeeting()"
                            >
                                Cancel
                            </button>
                        </template>

                        <template v-else>
                            <button
                                type="button"
                                id="editMeetingMenu"
                                class="btn btn-sm meeting-btn-outline text-primary me-2"
                                data-bs-toggle="dropdown"
                            >
                                Edit
                                <img class="rotate-90" src="../../../assets/images/openicon.svg" />
                            </button>

                            <div class="dropdown-menu" aria-labelledby="editMeetingMenu">
                                <a class="dropdown-item" href="javascript:void(0);" @click="editMeeting(false)">
                                    <img src="../../../assets/images/chat/edit-pencil.svg" /> This event
                                </a>
                                <a class="dropdown-item" href="javascript:void(0);" @click="editMeeting(true)">
                                    <img src="../../../assets/images/chat/edit-pencil.svg" /> All events in the series
                                </a>
                            </div>

                            <button
                                type="button"
                                id="cancelMeetingMenu"
                                class="btn btn-sm meeting-btn-outline text-danger me-2"
                                data-bs-toggle="dropdown"
                            >
                                Cancel
                                <img class="rotate-90" src="../../../assets/images/openicon.svg" />
                            </button>
                            <div class="dropdown-menu" aria-labelledby="cancelMeetingMenu">
                                <a class="dropdown-item" href="javascript:void(0);" @click="cancelMeeting(false)">
                                    <img src="../../../assets/images/chat/edit-pencil.svg" /> This event
                                </a>
                                <a class="dropdown-item" href="javascript:void(0);" @click="cancelMeeting(true)">
                                    <img src="../../../assets/images/chat/edit-pencil.svg" /> All events in the series
                                </a>
                            </div>
                        </template>
                    </template>

                    <div class="meeting-btn-outline">
                        <i
                            class="fas fa-ellipsis-h font-size-lg ms-md-1 py-1 ps-md-1 mx-2 cursor-pointer"
                            data-bs-toggle="dropdown"
                        ></i>
                        <div class="dropdown-menu py-1" aria-labelledby="Meeting-Options">
                            <a
                                class="dropdown-item font-size-sm d-flex align-items-center"
                                href="javascript:void(0);"
                                @click="forwardMeeting"
                            >
                                <img class="me-2" src="../../../assets/images/chat/forward.svg" /> Forward
                            </a>
                        </div>
                    </div>
                </section>
            </section>
            <section class="event-details-layout">
                <div class="section-underline">
                    <h6 class="font-size-sm fw-semibold">Details</h6>
                    <div class="mb-1 d-flex align-items-center">
                        <img class="me-2" src="../../../assets/images/chat/calendar-icon.svg" />{{ eventDate }}
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                        <img class="me-2" src="../../../assets/images/chat/calendar-clock.svg" /><span>{{
                            eventTime
                        }}</span>
                    </div>
                    <div v-if="isRecurring" class="d-flex align-items-center">
                        <img class="me-2" src="../../../assets/images/chat/recurrence-icon.svg" />
                        <div>
                            {{ occurenceText(recurrenceStartDate, recurrenceEndDate, recurrenceType, daysOfWeek) }}
                        </div>
                    </div>
                </div>

                <div class="section-underline py-2">
                    <h6 class="font-size-sm fw-semibold">Participants</h6>
                    <div class="d-flex align-items-center">
                        <img src="../../../assets/images/chat/multiple-users.svg" />
                        <div class="ms-2">{{ organizerName }}<span class="ms-1 text-muted">(organizer)</span></div>
                    </div>
                    <div>
                        <img class="me-2" src="../../../assets/images/chat/multiple-users.svg" /><span>{{
                            getParticipantNames
                        }}</span>
                    </div>
                </div>

                <div v-if="description.length" class="py-2">
                    <h6 class="font-size-sm fw-semibold">Description</h6>
                    <div>{{ description }}</div>
                </div>
            </section>
        </section>
    </div>
</template>

<script lang="ts" src="./MeetingDetails.ts"></script>
<style src="./MeetingDetails.scss"></style>
